import React, { useState } from 'react'

function EmailCapture() {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [error, setError] = useState('')

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    // Clear previous error
    setError('')
    
    // Validate email
    if (!email.trim()) {
      setError('Please enter your email address.')
      return
    }
    
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.')
      return
    }
    
    setIsSubmitting(true)
    
    // Format the waitlist signup data like 3rx.com template
    try {
      const timestamp = new Date().toISOString()
      const signupData = {
        email: email,
        timestamp: timestamp,
        source: 'companionspromise.com Coming Soon Page',
        subject: `New Waitlist Signup - companionspromise.com`
      }

      // Format the message for email notification
      const emailBody = `New Waitlist Signup - companionspromise.com
Email: ${signupData.email}
Timestamp: ${signupData.timestamp}
Source: ${signupData.source}`

      // For now, log the formatted data (replace with actual API call)
      console.log('Waitlist Signup:', emailBody)
      
      // Send to our AWS Lambda API endpoint
      // This will send emails directly to info@companionspromise.com via AWS SES
      const API_ENDPOINT = 'https://zr60ip1b7g.execute-api.us-east-1.amazonaws.com/prod/waitlist';
      
      const apiData = {
        email: signupData.email,
        timestamp: signupData.timestamp,
        source: signupData.source
      };

      console.log('Sending to Lambda API:', apiData);
      console.log('Email format that will be sent:', emailBody);
      
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiData)
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error('API error:', errorData);
        throw new Error(`Failed to submit signup: ${response.status}`);
      }

      const result = await response.json();
      console.log('Waitlist signup processed:', result);
      
      // Show success message
      setTimeout(() => {
        setShowSuccess(true)
        setEmail('')
        setIsSubmitting(false)
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setShowSuccess(false)
        }, 5000)
      }, 1000)
      
    } catch (err) {
      setError('Something went wrong. Please try again.')
      setIsSubmitting(false)
    }
  }

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-6 sm:p-8 max-w-lg mx-auto border border-gray-200 animate-fade-in-up">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Get Early Access</h2>
      <p className="text-gray-600 mb-6">
        Be the first to know when Companion Promise launches in your area
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4" noValidate>
        <div>
          <label htmlFor="email" className="sr-only">Email address</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            aria-label="Email address for notifications"
            className={`w-full px-4 py-4 text-lg border rounded-xl focus:ring-2 focus:ring-cp-primary focus:border-cp-primary transition-colors duration-200 bg-white/90 ${
              error ? 'border-red-300' : 'border-gray-300'
            }`}
          />
          {error && (
            <div className="mt-2 text-sm text-red-600" role="alert">
              {error}
            </div>
          )}
        </div>
        
        <button 
          type="submit"
          disabled={isSubmitting}
          className={`w-full bg-cp-primary text-white py-4 px-8 text-lg font-semibold rounded-xl focus:ring-2 focus:ring-cp-primary focus:ring-offset-2 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 ${
            isSubmitting 
              ? 'opacity-75 cursor-not-allowed' 
              : 'hover:bg-cp-primary/90'
          }`}
        >
          {isSubmitting ? 'Adding you...' : 'Notify Me When It\'s Ready'}
        </button>
      </form>
      
      {showSuccess && (
        <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg animate-pulse-success">
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
            </svg>
            <span className="font-medium">Thank you! We'll notify you as soon as Companion Promise is ready.</span>
          </div>
        </div>
      )}
      
      <p className="text-sm text-gray-500 mt-6">
        We'll only send you updates about Companion Promise. No spam, ever.
      </p>
    </div>
  )
}

export default EmailCapture